import Login from "./login";
import BackButton from "./back-button";

const LoginModal = ({ close = false, setLoginOpen }) => {
  return (
    <div className="login-modal-bg">
      <div className="login-modal-inner same-color">
        <BackButton close={close} setLoginOpen={setLoginOpen} />
        <div className="login-modal-closer" />
        <div className="login-modal">
          <Login />
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
